"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _lodash = require("lodash");
var _HBToast = require("./HBToast.types");
var _SystemToast = require("./SystemToast/SystemToast");
var _variables = require("../../styles/variables");
var _MemberToastManager = _interopRequireDefault(require("./MemberToast/MemberToastManager"));
var _mixins = require("../../styles/mixins");
var _error = require("../common/error.utils");
var isSystemToast = function isSystemToast(toast) {
  return toast.type !== _HBToast.ToastType.MemberToast;
};
var HBToast = function HBToast(_ref) {
  var className = _ref.className,
    removeItem = _ref.removeItem,
    toasts = _ref.toasts,
    buttonTheme = _ref.buttonTheme;
  var _partition = (0, _lodash.partition)(toasts, isSystemToast),
    _partition2 = (0, _slicedToArray2["default"])(_partition, 2),
    systemToasts = _partition2[0],
    memberToasts = _partition2[1];
  var isMemberToastsActive = !!buttonTheme;
  if (memberToasts.length > 0 && !isMemberToastsActive) {
    (0, _error.trackError)(new Error('@HBToast: Unexpected - Member toasts were added but there is no button theme provided.'));
  }
  return /*#__PURE__*/_react["default"].createElement(ToastsContainer, {
    "data-testid": "hb-toast--toasts-container"
  }, /*#__PURE__*/_react["default"].createElement(SystemToastContainer, {
    className: className
  }, systemToasts.map(function (systemToast) {
    return /*#__PURE__*/_react["default"].createElement(_SystemToast.SystemToast, (0, _extends2["default"])({}, systemToast, {
      key: systemToast.id,
      removeItem: removeItem
    }));
  })), isMemberToastsActive && /*#__PURE__*/_react["default"].createElement(_MemberToastManager["default"], {
    toasts: memberToasts,
    removeItem: removeItem,
    buttonTheme: buttonTheme
  }));
};
var _default = exports["default"] = HBToast; // -------------------------------- Styles -------------------------------- //
var ToastsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBToast__ToastsContainer",
  componentId: "sc-1y49c7y-0"
})(["", ";"], _mixins.hideInPrint);
var SystemToastContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBToast__SystemToastContainer",
  componentId: "sc-1y49c7y-1"
})(["position:fixed;right:0;margin-inline:12px;top:40px;z-index:", ";transition:all 0.4 ease-in-out;"], _variables.Z_INDEX.TOAST);
//# sourceMappingURL=HBToast.js.map